import { render, staticRenderFns } from "./SummaryAllProjects.vue?vue&type=template&id=22dd8b79&scoped=true"
import script from "./SummaryAllProjects.vue?vue&type=script&lang=ts"
export * from "./SummaryAllProjects.vue?vue&type=script&lang=ts"
import style0 from "./SummaryAllProjects.vue?vue&type=style&index=0&id=22dd8b79&prod&lang=scss"
import style1 from "./SummaryAllProjects.vue?vue&type=style&index=1&id=22dd8b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd8b79",
  null
  
)

export default component.exports